export default [
    {
        path: '/purchase',
        meta: {
            title: "Purchase Requisition",
            icon: "purchase.png",
            show: true
        },
        component: () => import(/* webpackChunkName: "purchase" */ '../views/admin/page/PurchasesPage/Index'),
        redirect: { name: 'purchaserequisition' },
        children: [
            {
                path: 'tracking',
                name: 'tracking',
                meta: {
                    title: "Purchase Tracking",
                    show: true
                },
                component: () => import(/* webpackChunkName: "purchase" */ '../views/admin/page/Tracking/TrackingPurchase'),
            },
            {
                path: 'tracking/:id',
                name: 'trackingdetail',
                meta: {
                    title: "Tracking Purchase Detail",
                    show: false
                },
                props: true,
                component: () => import(/* webpackChunkName: "purchase" */ '../views/admin/page/Tracking/TrackingDetail'),
            },
            {
                path: 'purchaserequisition',
                name: 'purchaserequisition',
                meta: {
                    title: "Purchase Requisition",
                    show: true
                },
                component: () => import(/* webpackChunkName: "purchase" */ '../views/admin/page/PurchasesPage/PurchaseRequisition'),
            },
            {
                path: 'purchaserequisition/:id',
                name: 'purchaserequisitiondetail',
                meta: {
                    title: "Purchase Requisition Detail",
                    show: false
                },
                props: true,
                component: () => import(/* webpackChunkName: "purchase" */ '../views/admin/page/PurchasesPage/PurchaseRequisitionDetail'),
            },
            {
                path: 'purchaseorder',
                name: 'purchaseorder',
                meta: {
                    title: "Purchase Order",
                    show: true
                },
                component: () => import(/* webpackChunkName: "purchase" */ '../views/admin/page/PurchasesPage/PurchaseOrder'),
            },
            {
                path: 'purchaseorder/:id',
                name: 'purchaseorderid',
                meta: {
                    title: "Purchase Order Detail",
                    show: false
                },
                props: true,
                component: () => import(/* webpackChunkName: "purchase" */ '../views/admin/page/PurchasesPage/PurchaseOrderDetail'),
            },
            {
                path: 'purchaseorder/:id/:role',
                name: 'purchaseorderdetail',
                meta: {
                    title: "Purchase Order Detail",
                    show: false
                },
                props: true,
                component: () => import(/* webpackChunkName: "purchase" */ '../views/admin/page/PurchasesPage/PurchaseOrderDetail'),
            }

        ]
    },
]